import React from 'react'
import PropTypes from 'prop-types'
import { Stamp } from './style'

const StampBlackFeirao = ({ width, height }) => (
  <Stamp width={width} height={height} />
)

StampBlackFeirao.defaultProps = {
  width: '84px',
  height: '23px',
}

StampBlackFeirao.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default StampBlackFeirao
